"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reconstruct = reconstruct;
const ml_spectra_processing_1 = require("ml-spectra-processing");
/**
 * Reconstruct a mass spectrum from a set of molecular formulas
 * that has the  distribution property
 * @param {object[]} mfs
 * @param {object} [options={}]
 * @param {import('cheminfo-types').Logger} [options.logger]
 * @param {object}        [options.mass={}]
 * @param {number}        [options.mass.precision=0] -  Precision (accuracy) of the monoisotopic mass in ppm
 * @param {string|Function} [options.mass.peakWidthFct=()=>0.01]
 */
const getPeakWidthFct_js_1 = require("./getPeakWidthFct.js");
function reconstruct(mfs, options = {}) {
    const delta = (0, getPeakWidthFct_js_1.getPeakWidthFct)(options);
    const data = mfs.map((mf) => mf.distribution);
    const reconstructed = (0, ml_spectra_processing_1.xyArrayWeightedMerge)(data, { delta });
    return reconstructed;
}
//# sourceMappingURL=reconstruct.js.map